module.exports = __webpack_public_path__ + "img/Slide36.503f4680.png";